// removed by extract-text-webpack-plugin
module.exports = {"term":"Definition-hashed__term__2I2D0","definition":"Definition-hashed__definition__IzWVy"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/definition-list/Definition/Definition-hashed.scss
// module id = 1201
// module chunks = 0